export class Brand {
  constructor(readonly name: string) {}
}
